<template>
  <div class="prcie_solo">
    <Menu />
    <div class="cont">
      <pricingTop />
      <div class="tabs">
        <router-link class="titem titem0" to="/pricing_individual.html">个人专属</router-link>
        <router-link class="titem titem1" to="/pricing_enterprise.html"
          >企业专属</router-link
        >
        <router-link class="titem titem1" to="/pricing_desktron.html">云桌面</router-link>
      </div>
       <!-- 性能版 -->
      <div class="high_bx perform_bx">
        <div class="title_bx">
          <img class="perform" src="@/assets/menu/perform@2x.png" alt="" />
          <p>性能版</p>
        </div>
        <p class="desc0">适用于色彩设计创作</p>
        <p class="desc1">远程设计创作的极致体验</p>
        <div class="price_bx">
          <p class="t1">¥</p>
          <p class="t2">95</p>
          <p class="t3">/月（连续包月）</p>
        </div>
        <div class="src_price">
          <p class="t1">¥148/月（单月）</p>
        </div>
        <a :href="_uc_mb_hostName" class="to_btn">立即使用</a>
        <p class="line"></p>
        <div class="desc_item">
          <span class="t1">基础版所有功能</span>
        </div>
        <div class="desc_item">
          <span class="t1">自带真彩、数位板、多屏幕等专属操作</span>
        </div>
        <div class="desc_item">
          <span class="t1">RTC+VIP专属高速机房通道</span>
        </div>
        <div class="desc_item">
          <img
            style="width: 34px; marginright: 3px"
            src="@/assets/pricing2/solo/picq_game@2x.png"
            alt=""
          /><span class="t1">最高4K60FPS (原画) /</span>
        </div>
        <div class="desc_item">
          <img
            style="width: 34px; marginright: 3px"
            src="@/assets/pricing2/solo/2K@2x.png"
            alt=""
          /><span class="t1">最高2K144FPS(需v4.7.0.1及以上)</span>
        </div>
        <div class="desc_item">
          <span class="t1">鼠标加速通道：最高120hz</span>
        </div>
        <div class="desc_item">
          <img
            style="width: 18px; marginleft: 2px"
            v-for="i of 5"
            :key="i"
            src="@/assets/pricing2/solo/hstar@2x.png"
            alt=""
          /><span style="marginleft: 6px" class="t1">高速文件服务器</span>
        </div>
        <router-link to="/pricing/solodetail?tab=3" class="desc_full">
          <span>查看完整功能特权</span>
          <img src="@/assets/pricing2/solo/angle@2x.png" alt="" />
        </router-link>
      </div>
      <!-- 游戏版 -->
      <div class="high_bx game_bx">
        <div class="title_bx">
          <img class="game" src="@/assets/menu/game@2x.png" alt="" />
          <p>游戏版</p>
        </div>
        <p class="desc0">适用于游戏用户</p>
        <p class="desc1">畅享高玩体验，快乐无边界</p>
        <div class="price_bx">
          <p class="t1">¥</p>
          <p class="t2">42</p>
          <p class="t3">/月（连续包月）</p>
        </div>
        <div class="src_price">
          <p class="t1">¥68/月（单月）</p>
        </div>
        <a :href="_uc_mb_hostName" class="to_btn">立即使用</a>
        <p class="line"></p>
        <div class="desc_item">
          <span class="t1">基础版所有功能</span>
        </div>
        <div class="desc_item">
          <span class="t1">RTC+VIP专属高速机房通道</span>
        </div>
        <div class="desc_item">
          <img
            style="width: 34px; marginright: 3px"
            src="@/assets/pricing2/solo/picq_game@2x.png"
            alt=""
          /><span class="t1">最高4K60FPS (原画) /</span>
        </div>
        <div class="desc_item">
          <img
            style="width: 34px; marginright: 3px"
            src="@/assets/pricing2/solo/2K@2x.png"
            alt=""
          /><span class="t1">最高2K144FPS(需v4.7.0.1及以上)</span>
        </div>
        <div class="desc_item">
          <span class="t1">鼠标加速通道：最高120hz</span>
        </div>
        <div class="desc_item">
          <img
            style="width: 18px; marginleft: 2px"
            v-for="i of 5"
            :key="i"
            src="@/assets/pricing2/solo/star4@2x.png"
            alt=""
          /><span style="marginleft: 6px" class="t1">高速文件服务器</span>
        </div>
        <router-link to="/pricing/solodetail?tab=2" class="desc_full">
          <span>查看完整功能特权</span>
          <img src="@/assets/pricing2/solo/angle@2x.png" alt="" />
        </router-link>
      </div>
      <!-- 专业版 -->
      <div class="high_bx pro_bx">
        <div class="title_bx">
          <img src="@/assets/menu/pro@2x.png" alt="" />
          <p>专业版</p>
        </div>
        <p class="desc0">适用于高效办公需求</p>
        <p class="desc1">低延迟、专业级的远控体验</p>
        <div class="price_bx">
          <p class="t1">¥</p>
          <p class="t2">24</p>
          <p class="t3">/月（连续包月）</p>
        </div>
        <div class="src_price">
          <p class="t1">¥40/月（单月）</p>
        </div>
        <a :href="_uc_mb_hostName" class="to_btn">立即使用</a>
        <p class="line"></p>
        <div class="desc_item">
          <span class="t1">基础版所有功能</span>
        </div>
        <div class="desc_item">
          <span class="t1">RTC+VIP专属高速机房通道</span>
        </div>
        <div class="desc_item">
          <img
            style="width: 34px; marginright: 3px"
            src="@/assets/pricing2/solo/2K@2x.png"
            alt=""
          /><span class="t1">最高2K30FPS (超清)</span>
        </div>
        <div class="desc_item">
          <span class="t1">鼠标加速通道：最高60hz</span>
        </div>
        <div class="desc_item">
          <img
            style="width: 18px; marginleft: 2px"
            v-for="i of 3"
            :key="i"
            src="@/assets/pricing2/solo/pstar@2x.png"
            alt=""
          /><span style="marginleft: 6px" class="t1">高速文件服务器</span>
        </div>
        <router-link to="/pricing/solodetail?tab=1" class="desc_full">
          <span>查看完整功能特权</span>
          <img src="@/assets/pricing2/solo/angle@2x.png" alt="" />
        </router-link>
      </div>
      <!-- 个人版 -->
      <div class="high_bx base_bx">
        <div class="title_bx">
          <p>个人版</p>
        </div>
        <p class="desc0">适用于个人发起临时远控</p>
        <div class="price_title">仅个人使用</div>
        <router-link to="/download" class="to_btn">立即下载</router-link>
        <p class="line"></p>
        <div class="desc_item"><span class="t1">免费机房</span></div>
        <div class="desc_item">
          <span class="t1">最高1080p (高清) 画质</span>
        </div>
        <div class="desc_item">
          <span class="t1">鼠标加速通道：最高20hz</span>
        </div>
        <div class="desc_item"><span class="t1">文件传输</span></div>
        <!-- <div class="desc_item"><span class="t1">设备列表：100</span></div> -->
        <div class="desc_item"><span class="t1">远程开机</span></div>
        <div class="desc_item"><span class="t1">远程鼠标</span></div>
        <div class="desc_item"><span class="t1">锁定鼠标</span></div>
        <div class="desc_item"><span class="t1">锁屏</span></div>
        <router-link to="/pricing/solodetail" class="desc_full">
          <span>查看完整功能特权</span>
          <img src="@/assets/pricing2/solo/angle@2x.png" alt="" />
        </router-link>
      </div>
      <!-- 插件搭配 -->
      <div class="plugin_bx" ref="pluginPositon">
        <h1 class="title">搭配不同商品<br />让远控体验更完美</h1>
        <div class="pitem_bx">
          <div class="pitem" v-for="(item, index) in pugin_list" :key="index">
            <img class="desc_icon" :src="item.url" alt="" />
            <p class="desc_title">{{ item.title }}</p>
            <p
              class="desc_item"
              v-for="(ditem, dindex) in item.desc"
              :key="dindex"
            >
              {{ ditem }}
            </p>
            <a :href="`${_uc_mb_hostName}${item.link}`" class="purch_btn">
              <span>立即购买</span>
              <img src="@/assets/home/right.png" alt="" />
            </a>
          </div>
        </div>
        <p class="sub_desc">
          *VIP用户购买部分商品享受专属折扣，部分商品可选1年/1个月/连续包月三种不同的订阅方式
        </p>
      </div>
      <!-- 常见购买问题 -->
      <div class="purch_qs" v-if="qs_list.length > 0">
        <h1 class="title">购买常见问题</h1>
        <router-link
          class="qs_item"
          :to="`/helpcenter/${
            item.type == 0
              ? 'questions'
              : item.type == 1
              ? 'solo'
              : 'enterprise'
          }/${item.id}`"
          v-for="(item, index) in qs_list"
          :key="index"
        >
          <img src="~@/assets/pricing2/solo/right_black@2x.png" alt="" />
          <span>{{ item.title }}</span>
        </router-link>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Menu from "@/components/menu";
import Footer from "@/components/footer";
import pricingTop from "@/components/pricingTop";
export default {
  components: {
    Menu,
    Footer,
    pricingTop,
  },
  async created() {
    await this.getData();
  },
  mounted() {
    if (this.$route.query.pt == 3) {
      window.scrollTo(0, this.$refs.pluginPositon.offsetTop - 30);
    }
  },
  data() {
    return {
      pugin_list: [
        {
          url: "https://todeskcdnspeed.todesk.com/main_pic_6.svg",
          title: "免root控制安卓",
          icon: "mroot.png",
          desc: ["开启辅助权限", "控制安卓设备"],
          link: "/orderManage/buyOrder?spuId=6&orderType=0",
        },
        {
          url: "https://todeskcdnspeed.todesk.com/main_pic_5.svg",
          title: "多通道",
          icon: "dtd.png",
          desc: ["多主控", "同时发起远控"],
          link: "/orderManage/buyOrder?spuId=5&orderType=0",
        },
        {
          url: "https://todeskcdnspeed.todesk.com/main_pic_7.svg",
          title: "全球节点",
          icon: "qqjd.png",
          desc: ["流畅跨境远控", "打通地域边界"],
          link: "/orderManage/buyOrder?spuId=7&orderType=0",
        },
        {
          url: "https://todeskcdnspeed.todesk.com/main_pic_16.svg",
          title: "xp特别版",
          icon: "",
          desc: ["可使用xp系统设备", "作为主控/被控"],
          link: "/orderManage/buyOrder?spuId=16&orderType=0",
        },
      ],
      qs_list: [],
    };
  },
  methods: {
    async getData() {
      try {
        const res = await this.$serve.searchData({
          title: "购买常见问题",
        });
        this.qs_list = res.data.list;
        // eslint-disable-next-line no-empty
      } catch (error) {}
    },
  },
};
</script>
<style lang="less" scoped>
.prcie_solo {
  background: #fff;
  /deep/ .cont {
    background: url("~@/assets/pricing/pricing_bg@3x.png") no-repeat;
    background-size: 100% auto;
    background-repeat: no-repeat;
    .tabs {
      width: 326px;
      height: 50px;
      background: #FFFFFF;
      border-radius: 25px;
      padding: 4px;
      box-sizing: border-box;
      margin: auto;
      margin-top: 32px;
      box-shadow: 0 3px 6px rgba(0,0,0,.05);
      .titem {
        width: 106px;
        height: 42px;
        border-radius: 21px;
        display: inline-block;
        text-align: center;
        line-height: 42px;
      }
      .titem0 {
        background: #37B3FC;
        box-shadow: 0px 2px 4px 0px rgba(0, 68, 152, 0.18);
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
      }
      .titem1 {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #131314;
      }
    }
    .high_bx {
      width: 327px;
      background: #ffffff;
      border-radius: 10px;
      border: 1px solid rgba(0, 0, 0, 0.08);
      text-align: center;
      margin: auto;
      margin-top: 24px;
      padding-top: 36px;
      padding-bottom: 24px;
      .title_bx {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .title_bx img {
        width: 28px;
        height: 28px;
        &.game {
          width: auto;
          height: 28px;
        }
        &.perform {
          width: auto;
          height: 28px;
          margin-top: 2px;
        }
      }
      .title_bx p {
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #272727;
        margin-left: 4px;
      }
      .desc0 {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #83888f;
        margin-top: 9px;
      }
      .desc1 {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #131314;
        margin-top: 16px;
      }
      .price_bx {
        margin-top: 40px;
        display: flex;
        justify-content: center;
        align-items: baseline;
      }
      .price_bx .t1 {
        font-size: 16px;
        font-family: Barlow-Medium, Barlow;
        font-weight: 500;
        color: #f64041;
        margin-right: 2px;
      }
      .price_bx .t2 {
        font-size: 36px;
        font-family: Barlow-SemiBold, Barlow;
        font-weight: 600;
        color: #f64041;
      }
      .price_bx .t3 {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #f64041;
        margin-left: 2px;
      }
      .src_price {
        display: flex;
        justify-content: center;
        margin-top: 10px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #83888f;
      }
      .src_price .t2 {
        text-decoration: line-through;
      }
      .to_btn {
        display: block;
        margin: auto;
        margin-top: 24px;
        width: 210px;
        height: 50px;
        background: #252220;
        border-radius: 10px;
        text-align: center;
        line-height: 50px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #f8cfb0;
      }
      .buy_desc {
        margin-top: 12px;
        display: flex;
        justify-content: center;
      }
      .buy_desc .t1 {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #131314;
      }
      .buy_desc .t2 {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #0070f9;
        margin-left: 8px;
      }
      .line {
        width: 100%;
        height: 0;
        border-bottom: 1px solid #ebedf0;
        margin-top: 32px;
      }
      .desc_item {
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .desc_item .t1 {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #131314;
      }
      .desc_full {
        margin-top: 23px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .desc_full span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #0070f9;
      }
      .desc_full img {
        margin-left: 4px;
        width: 12px;
      }
    }
    // 游戏版
    .perform_bx {
      .to_btn {
        background: #222326;
        color: #FCD4A7;
      }
    }
    // 游戏版
    .game_bx {
      .to_btn {
        background: #521a97;
        color: #fff;
      }
    }
    // 专业版
    .pro_bx {
      .to_btn {
        background: #0070f9;
        color: #fff;
      }
    }
    // 基础版
    .base_bx {
      background-image: none;
      margin-bottom: 32px;
      .price_title {
        margin-top: 32px;
        font-size: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #131314;
        margin-bottom: 48px;
      }
      .to_btn {
        color: #0070f9;
        box-sizing: border-box;
        border: 1px solid #0070f9;
        background: #fff;
      }
    }
    // 插件搭配
    .plugin_bx {
      background: #f4f6f8;
      padding-bottom: 20px;
      padding-top: 32px;
      text-align: center;
      .title {
        font-size: 30px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #222429;
        line-height: 42px;
      }
      .pitem_bx {
        padding-left: 24px;
        padding-right: 24px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
      }
      .pitem {
        width: 156px;
        height: 230px;
        background: #ffffff;
        box-shadow: 0px 2px 23px 0px rgba(0, 0, 0, 0.06);
        border-radius: 4px;
        border: 1px solid rgba(38, 39, 41, 0.08);
        margin-top: 24px;
        box-sizing: border-box;
        padding-top: 22px;
        text-align: center;
      }
      .pitem .desc_icon {
        height: 70px;
        width: auto;
      }
      .pitem .desc_title {
        margin-top: 4px;
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        color: #222429;
        margin-bottom: 14px;
      }
      .pitem .desc_item {
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 17px;
        color: #747576;
        text-align: center;
      }
      .pitem .purch_btn {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 24px;
        span {
          font-family: "PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #0070f9;
        }
        img {
          margin-left: 4px;
          width: 4px;
          height: auto;
        }
      }
      .sub_desc {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #83888f;
        line-height: 20px;
        margin-top: 24px;
      }
    }
    // 常见购买问题
    .purch_qs {
      padding-top: 32px;
      padding-bottom: 16px;
      padding-left: 24px;
      padding-right: 24px;
      .title {
        font-size: 30px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #222429;
        margin-bottom: 16px;
      }
      .qs_item {
        padding: 16px 8px;
        display: flex;
        align-items: flex-start;
        border-bottom: 1px solid #d8d8d8;
        img {
          width: 17px;
          height: 17px;
          margin-top: 3px;
        }
        span {
          margin-left: 13px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #131314;
        }
      }
      .qs_item:last-of-type {
        border-bottom: none;
      }
    }
  }
}
</style>
